export const user_data = () => ({ type: "User_data" });
export const setuser_data = (payload) => ({
  type: "User_data",
  payload,
});

export const bearer_token = () => ({ type: "Bearer_token" });
export const setbearer_token = (payload) => ({
  type: "Bearer_token",
  payload,
});

export const current_store = () => ({ type: "Current_Store" });
export const setcurrent_store = (payload) => ({
  type: "Current_Store",
  payload,
});

export const current_cart = () => ({ type: "Current_Cart" });
export const setcurrent_cart = (payload) => ({
  type: "Current_Cart",
  payload,
});

export const userpermission_data = () => ({ type: "Userpermission_data" });
export const setuserpermission_data = (payload) => ({
  type: "Userpermission_data",
  payload,
});

export const appearance_settings = () => ({ type: "Appearance_settings" });
export const setappearance_settings = (payload) => ({
  type: "Appearance_settings",
  payload,
});

export const rolesandpermission_data = () => ({
  type: "Rolesandpermission_data",
});
export const setrolesandpermission_data = (payload) => ({
  type: "Rolesandpermission_data",
  payload,
});
